import { downloadData } from "./downloadData";

export const downloadBlobData = (data: Blob, filename: string) => {
  const url = window.URL.createObjectURL(data);
  downloadData(url, filename);
  window.URL.revokeObjectURL(url);
};
